<template>
  <ul class="tabs">
    <li
      class="tab"
      v-for="(item, index) in list"
      :key="index"
      :class="{ 'tab--active': activeTab === index }"
      @click="changeTab(index, item.value)"
    >
      {{ item.name }}
    </li>
  </ul>
</template>

<script>
export default {
  name: 'OrderFilter',
  props: {
    list: {
      type: Array
    }
  },
  data() {
    return {
      activeTab: 0
    }
  },
  methods: {
    changeTab(index, value) {
      this.activeTab = index
      this.$emit('change', value)
    }
  }
}
</script>

<style lang="scss" scoped>
.tabs {
  font-size: 14px;
  color: #262626;
  text-align: center;
  display: flex;

  .tab {
    cursor: pointer;
    width: 72px;
    height: 26px;
    line-height: 26px;
    background-color: #f0f0f0;
    border-radius: 2px;
    margin-left: 10px;
    font-size: 14px;
  }

  .tab--active {
    position: relative;
    color: #046bcc;

    // &::after {
    //   content: '';
    //   position: absolute;
    //   bottom: 0;
    //   left: 50%;
    //   transform: translateX(-50%);
    //   width: 34px;
    //   height: 4px;
    //   background-color: #046bcc;
    // }
  }
}
</style>
